import { Route } from "found";
import { Fragment } from "react";

import CatalixStartSessionErrorPage from "pstat-anywhere/components/integrations/catalix/StartSessionErrorPage";

// need routes for both /start_session and /start-session because when we test this error
// page with selenium, it uses the /start_session path that is defined in the backend urls.py,
// but the actually catalix path you see in the browser is /start-session, so when this error page
// is returned from catalix, the path is /start-session
const routes = (
  <Fragment>
    <Route
      path="/start_session"
      data={{
        routeName: "catalix_start_session_error"
      }}
      Component={CatalixStartSessionErrorPage}
    />
    <Route
      path="/start-session"
      data={{
        routeName: "catalix_start_session_error"
      }}
      Component={CatalixStartSessionErrorPage}
    />
  </Fragment>
);

export default routes;
